import React, {Fragment} from "react";
import FigureEditor from "../../editors/figureEditor";
import {ChildFragmentEditor} from "../../editors/FragmentEditor";
import TextArea from "../TextArea";
import EditorField from "../editor/editor";
import Button from "../Button";
import Modal from "../../layout/Modal";
import isEqual from "lodash-es/isEqual";
import {loadComponent, loadComponentById} from "../../../utils/components";
import classNames from "classnames";
import CheckBox from "../CheckBox";
import {isTrue} from "../../../utils/other";
import Tooltip from "../../../utils/Tooltip";
import Select from "../Select";
import ComponentConfig from "../ComponentConfig";
import {optionsTemplate} from "../../../utils/formatters";
import TextInput from "../TextInput";
import Portal from "../../layout/Portal";
import {empty} from "locutus/php/var";


export const LinkModal = (props) => {
    const {type, value, target} = props.data;
    return <div className="row">
        <div className="col-md-12">
            <div className="row form-row">
                <div className="col-md-12">
                    <Select name="type" objectValue={false} optionname="linktype" storeType="local" saveChanges={props.setValue} value={type} label="Link típusa" />
                </div>
            </div>
            <div className="row form-row">
                <div className="col-md-12">
                    {type && type !== "url"
                        ?
                        <ComponentConfig componentName={type}>
                            {(configProps) => {
                                const urlField = Object.keys(configProps.componentConfig.fielddefs || {}).find((field) => {
                                    return configProps.componentConfig.fielddefs[field].object === "url"
                                });
                                let valueKey = configProps.componentConfig.idfield;
                                if (urlField) {
                                    valueKey = configProps.componentConfig.fielddefs[urlField].boundfield || valueKey;
                                }
                                return <Select
                                    name="value"
                                    objectValue={false}
                                    component={type}
                                    valueKey={valueKey}
                                    groupBy={{
                                        by: [valueKey]
                                    }}
                                    optionsTemplate={optionsTemplate(type)}
                                    saveChanges={props.setValue}
                                    storeType="remote"
                                    value={value}
                                    label="Link tárgya"
                                />
                            }
                            }
                        </ComponentConfig>
                        :
                        <TextInput name="value" value={value || ''} saveChanges={(field, value) => props.setValue(field, value.trim())} label="Url" />
                    }
                </div>
            </div>
            {props.targetAble !== false && <div className="row form-row">
                <div className="col-md-12">
                    <CheckBox name="target" saveChanges={(field, value) => props.setValue(field, value ? '_blank' : null)} value={!!target} checked={!!target} label="Megnyitás új ablakban" />
                </div>
            </div>}
        </div>
    </div>;
};

class FigurePreview extends React.Component {

    state = {
        url: ''
    };

    constructor(props) {
        super(props);
        this.componentDidUpdate({}, {}, {});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.id !== prevProps.id) {
            if (this.props.id) {
                this.load = loadComponentById("figure", this.props.id, ["url"]);
                this.load.then((data) => {
                    this.setState({
                        url: data.url
                    });
                });
                this.load.catch(() => {
                    this.setState({
                        url: ''
                    });
                });
            } else {
                this.setState({
                    url: ''
                });
            }
        }
    }

    render() {
        return (
            !!this.state.url && <div className="figure-preview">
                <img src={this.state.url} alt={this.state.url} />
            </div>
        );
    }
}

class Preview extends React.Component {

    constructor(props) {
        super(props);
        const div = document.createElement("div");
        div.innerHTML = this.props.variable.value || '';
        this.state = {
            preview: div.innerText
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.variable.value !== prevProps.variable.value) {
            const div = document.createElement("div");
            div.innerHTML = this.props.variable.value || '';
            this.setState({
                preview: div.innerText
            });
        }
    }

    render() {
        if (this.props.variable.type === "attribute") {
            if (this.props.variable['edit-as']) {
                if (this.props.variable.component) {
                    if (this.props.variable.component === "figure") {
                        return <div className="preview"><FigurePreview id={this.props.variable.value} /></div>;
                    }
                }
            }
        }
        return (
            <div className="preview">{this.state.preview}</div>
        );
    }
}

const MjSection = {
    onVariableChanged: (variableNode, variableName, variable) => {
        if (!variable) {
            variableNode.parentNode.removeChild(variableNode);
            return;
        }
        variable = {...variable};
        Object.keys(variable).map((key) => {
            variableNode.setAttribute(key, variable[key]);
        });
    },
    parse: async (dataNode, nodeVariables) => {
        if (dataNode.getAttribute("data-id") + "" === "youtube") {
            const variables = {};
            nodeVariables.forEach((variableNode) => {
                Array.from(variableNode.attributes).forEach((attribute) => {
                    dataNode.setAttribute(attribute.name, attribute.value);
                    variables[attribute.name] = attribute.value;
                });
            });
            variables['background-figure'] = variables['background-figure'] || null;
            const figureId = variables['background-figure'] || dataNode.getAttribute("background-figure");
            if (figureId) {
                const figure = await loadComponentById("figure", figureId, ["url"]);
                dataNode.setAttribute("background-url", figure.url);
            }
            dataNode.removeAttribute("background-figure");
            const text = dataNode.querySelector(":scope [data-text]");
            if (text) {
                text.innerHTML = variables.text || text.getAttribute("data-text");
            }
            return variables;
        }
        return {};
    },
    editor: (props) => {
        return <Fragment>
            {props.componentId ? <FigureEditor
                component={props.component}
                componentId={props.componentId}
                list={ChildFragmentEditor}
                editor={() => <div/>}
                selection={props.variable['background-figure']}
                values={{}}
                loadForm={(img) => props.saveChanges("background-figure", img.figure_id)}
                isLoading={props.disabled}
                pageSize={0}
            /> : <Fragment>Kép megadása előtt mentsd el!</Fragment>}
            <TextArea name="text" label="Szöveg" value={props.variable.text} saveChanges={props.saveChanges} />
        </Fragment>;
    }
};

const MjText = {
    onVariableChanged: (variableNode, variableName, variable) => {
        if (!variable) {
            variableNode.parentNode.removeChild(variableNode);
            return;
        }
        variable = {...variable};
        if(variable.type === "node") {
            variableNode.innerHTML = variable.value;
        } else if (variable.type === "text") {
            variableNode.setAttribute("value", variable.value);
        }
        if (variable.style) {
            variableNode.setAttribute("style", variable.style);
        } else {
            variableNode.removeAttribute("style");
        }
    },
    parse: async (dataNode, nodeVariables) => {
        const variables = {};
        let content = null;
        let type = dataNode.getAttribute("data-type");
        let styleString = dataNode.getAttribute("data-styles");
        const styles = {};
        let def = null;
        if (styleString) {
            styleString.split(",").map((style) => {
                const s = style.split(":");
                if (s[0].indexOf("!") === 0) {
                    s[0] = s[0].substr(1, s[0].length - 1);
                    def = s[0];
                }
                styles[s[0]] = s[1];
            });
        }
        variables.styles = styles;
        variables.defaultStyle = def;
        variables.optionalFlag = dataNode.hasAttribute("data-optional");
        let optional = true;
        nodeVariables.forEach((variableNode) => {
            Array.from(variableNode.attributes).forEach((attribute) => {
                if (attribute.name !== "value" && attribute.name !== "data-type" && attribute.name !== "style" && attribute.name !== "optional") {
                    dataNode.setAttribute(attribute.name, attribute.value);
                } else if (attribute.name === "style") {
                    variables.style = attribute.value;
                } else if (attribute.name === "optional") {
                    optional = attribute.value;
                    optional = optional === "true" || optional === "1";
                }
            });
            if (type === "node") {
                content = variableNode.innerHTML;
            } else if (type === "text") {
                content = variableNode.getAttribute("value");
            }
        });
        optional = optional ? "true" : "false";
        variables.optional = optional;
        if (optional === "false") {
            const parent = dataNode.parentNode;
            parent.removeChild(dataNode);
        } else {
            const styleClass = ((dataNode.getAttribute("css-class") || "") + " " + (((variables.style || def) && (styles[variables.style || def] || styles[def])) || "")).trim();
            if (!!styleClass) {
                dataNode.setAttribute("css-class", styleClass);
            }
            variables.value = content;
            variables.type = type;
            if (content) {
                dataNode.innerHTML = content;
            }
            const removeType = dataNode.getAttribute("data-remove");
            if (removeType === "parent") {
                if (!(content || dataNode.innerHTML.trim())) {
                    const parent = dataNode.parentNode;
                    parent.removeChild(dataNode);
                    if (!parent.childNodes.length) {
                        parent.parentNode.removeChild(parent);
                    }
                }
            }
        }
        return variables;
    },
    editor: (props) => {
        const type = props.variable.type;
        let editor = null;
        if (type === "node") {
            editor = <EditorField
                name="value"
                toolbar={['bold', 'italic', 'underline', 'strike', 'link', 'unlink']}
                label={false}
                value={props.variable.value}
                saveChanges={props.saveChanges}
            />;
        } else if (type === "text") {
            editor = <TextArea
                name="value"
                label={false}
                value={props.variable.value}
                saveChanges={props.saveChanges}
            />
        }
        return <Fragment>
            {editor}
            <div className="styles">
                {Object.keys(props.variable.styles || {}).map((style) => {
                    return <span className={classNames("style", {active: (props.variable.style || props.variable.defaultStyle) === style})} onClick={() => {
                        props.saveChanges("style", style);
                    }}>{style}</span>
                })}
            </div>
            {props.variable.optionalFlag && <div className="row">
                <div className="col-md-12">
                    <CheckBox
                        name="optional"
                        type="bool"
                        value={isTrue(props.variable.optional)}
                        label="Látható"
                        checked={isTrue(props.variable.optional)}
                        saveChanges={(field, value) => {
                            props.saveChanges(field, isTrue(value) ? "true" : "false");
                        }}
                    />
                </div>
            </div>}
        </Fragment>;
    }
};

const MjPreview = {
    onVariableChanged: (variableNode, variableName, variable) => {
        if (!variable) {
            variableNode.parentNode.removeChild(variableNode);
            return;
        }
        variable = {...variable};
        variableNode.setAttribute("value", variable.value);
    },
    parse: async (dataNode, nodeVariables) => {
        const variables = {};
        let content = null;
        nodeVariables.forEach((variableNode) => {
            content = variableNode.getAttribute("value");
        });
        variables.value = content;
        dataNode.innerHTML = content;
        return variables;
    },
    editor: (props) => {
        return <TextArea name="value" label={false} value={props.variable.value} saveChanges={props.saveChanges} />
    }
};

const MjImage = {
    onVariableChanged: (variableNode, variableName, variable) => {
        if (!variable) {
            variableNode.parentNode.removeChild(variableNode);
            return;
        }
        Object.keys(variable).map((key) => {
            variableNode.setAttribute(key, variable[key]);
        });
    },
    parse: async (dataNode, nodeVariables) => {
        const variables = {};
        nodeVariables.forEach((variableNode) => {
            Array.from(variableNode.attributes).forEach((attribute) => {
                variables[attribute.name] = attribute.value;
            });
        });
        variables.optionalFlag = dataNode.hasAttribute("data-optional");
        variables.switch = dataNode.getAttribute("data-switch");
        if (variables.switch) {
            variables.switch = JSON.parse(variables.switch);
        }
        let optional = variables.optionalFlag ? (variables['optional'] === undefined || variables['optional'] === "true" || variables['optional'] === "1") : true;
        optional = optional ? "true" : "false";
        variables.optional = optional;
        if (optional === "false") {
            const parent = dataNode.parentNode;
            parent.removeChild(dataNode);
        } else {
            if (variables.figure) {
                dataNode.setAttribute("id", variables.figure);
            }
            if (variables.type) {
                if (variables.value !== undefined) {
                    let url;
                    if (variables.type !== "url") {
                        if (variables.value) {
                            url = await loadComponent("url", {
                                filter: [{
                                    field: "component",
                                    value: variables.type
                                }, {
                                    field: "component_id",
                                    value: variables.value
                                }]
                            });
                        }
                    } else {
                        if (!isNaN(variables.value)) {
                            url = await loadComponentById("url", variables.value, ["url"]);
                        } else {
                            url = {url: variables.value}
                        }
                    }
                    if (url) {
                        dataNode.setAttribute("href", url.url);
                    }
                }
            }
            let removed = false;
            const removeType = dataNode.getAttribute("data-remove");
            if (removeType === "parent") {
                if (!dataNode.getAttribute("src") && !dataNode.getAttribute("id")) {
                    removed = true;
                    const parent = dataNode.parentNode;
                    parent.removeChild(dataNode);
                    if (!parent.innerHTML.trim()) {
                        parent.parentNode.removeChild(parent);
                    }
                }
            }
            if (!removed && !dataNode.getAttribute("src") && !dataNode.getAttribute("id")) {
                dataNode.parentNode.removeChild(dataNode);
            }
        }
        variables.figure = variables.figure || dataNode.getAttribute("id");
        return variables;
    },
    editor: (props) => {
        return <Fragment>
            {props.variable.switch ?
                <div className="mjml-editor">
                    <div className="image-switch">
                        {props.variable.switch.map((figure_id) => {
                            class Figure extends React.Component {
                                state = {};
                                componentDidMount() {
                                    this.figureRequest && this.figureRequest.abort();
                                    this.figureRequest = loadComponentById("figure", figure_id, ["url"]);
                                    this.figureRequest.then((figure) => {
                                        this.setState({figure});
                                    })
                                }

                                render() {
                                    return (
                                        <div className={classNames("image", {active: figure_id + "" === "" + props.variable.figure})} onClick={(e) => {
                                            e && e.preventDefault();
                                            props.saveChanges("figure", figure_id)
                                        }}>
                                            <div style={{backgroundImage: "url('" + ((this.state.figure || {}).url || '') + "')"}}/>
                                        </div>
                                    );
                                }
                            }
                            return <Figure />;
                        })}
                    </div>
                </div>
                :
                (
                    props.componentId ?
                        <FigureEditor
                            component={props.component}
                            componentId={props.componentId}
                            list={ChildFragmentEditor}
                            editor={() => <div/>}
                            selection={props.variable.figure}
                            values={{}}
                            loadForm={(img) => props.saveChanges("figure", img.figure_id)}
                            isLoading={props.disabled}
                            pageSize={0}
                        />
                        :
                        <Fragment>
                            Kép megadása előtt mentsd el!
                        </Fragment>
                )
            }
            <LinkModal data={{...props.variable}} targetAble={false} setValue={props.saveChanges} />
            {props.variable.optionalFlag && <div className="row">
                <div className="col-md-12">
                    <CheckBox
                        name="optional"
                        type="bool"
                        value={isTrue(props.variable.optional)}
                        label="Látható"
                        checked={isTrue(props.variable.optional)}
                        saveChanges={(field, value) => {
                            props.saveChanges(field, isTrue(value) ? "true" : "false");
                        }}
                    />
                </div>
            </div>}
        </Fragment>;
    }
};

const Link = {
    onVariableChanged: (variableNode, variableName, variable) => {
        if (!variable) {
            variableNode.parentNode.removeChild(variableNode);
            return;
        }
        Object.keys(variable).map((key) => {
            variableNode.setAttribute(key, variable[key]);
        });
    },
    parse: async (dataNode, nodeVariables) => {
        const variables = {};
        nodeVariables.forEach((variableNode) => {
            Array.from(variableNode.attributes).forEach((attribute) => {
                variables[attribute.name] = attribute.value;
            });
        });
        const optionalFlag = dataNode.hasAttribute("data-optional");
        variables.optionalFlag = optionalFlag;
        let optional = optionalFlag ? (variables['optional'] === undefined || variables['optional'] === "true" || variables['optional'] === "1") : true;
        optional = optional ? "true" : "false";
        variables.optional = optional;
        if (optional === "false") {
            const parent = dataNode.parentNode;
            parent.removeChild(dataNode);
        } else {
            if (variables.type) {
                if (variables.value !== undefined) {
                    let url;
                    if (variables.type !== "url") {
                        if (variables.value) {
                            url = await loadComponent("url", {
                                filter: [{
                                    field: "component",
                                    value: variables.type
                                }, {
                                    field: "component_id",
                                    value: variables.value
                                }]
                            });
                        }
                    } else {
                        if (!isNaN(variables.value)) {
                            url = await loadComponentById("url", variables.value, ["url"]);
                        } else {
                            url = {url: variables.value}
                        }
                    }
                    if (!empty(url?.url)) {
                        dataNode.setAttribute("href", url.url.replace(/ /g, '%20'));
                    } else {
                        // for joking ;-)
                        dataNode.setAttribute("href", "https://www.youtube.com/watch?v=dQw4w9WgXcQ");
                    }
                }
            }
            let removed = false;
            const removeType = dataNode.getAttribute("data-remove");
            if (removeType === "parent") {
                if (!dataNode.getAttribute("href")) {
                    removed = true;
                    const parent = dataNode.parentNode;
                    parent.removeChild(dataNode);
                    if (!parent.innerHTML.trim()) {
                        parent.parentNode.removeChild(parent);
                    }
                }
            }
            if (!removed && !dataNode.getAttribute("href")) {
                dataNode.parentNode.removeChild(dataNode);
            }
        }
        return variables;
    },
    editor: (props) => {
        return <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <LinkModal data={{...props.variable}} targetAble={false} setValue={props.saveChanges} />
                </div>
            </div>
            {props.variable.optionalFlag && <div className="row">
                <div className="col-md-12">
                    <CheckBox
                        name="optional"
                        type="bool"
                        value={isTrue(props.variable.optional)}
                        label="Látható"
                        checked={isTrue(props.variable.optional)}
                        saveChanges={(field, value) => {
                            props.saveChanges(field, isTrue(value) ? "true" : "false");
                        }}
                    />
                </div>
            </div>}
        </Fragment>;
    }
};

export default class NodeEditor extends React.Component {

    static nodes = {
        "div": MjText,
        "span": MjText,
        "a": Link,
        "mj-social-element": Link,
        "mj-section": MjSection,
        "mj-text": MjText,
        "mj-preview": MjPreview,
        "mj-image": MjImage
    };

    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            variable: this.props.variable
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.variable, prevProps.variable)) {
            this.setState({variable: this.props.variable});
        }
    }

    render() {
        return <div className="variable">
            <div className="data">
                <div className="name" onClick={() => this.setState({edit: true})}>
                    <Tooltip title={this.props.variableName}>{this.props.variableName}</Tooltip>
                </div>
                <div className="actions">
                    <Button tooltip="Módosítás" onClick={() => this.setState({edit: true})} icon={{lib: "fas", name: "pencil-alt"}} className="edit-btn"/>
                </div>
            </div>
            <Portal>
                <Modal
                    size="large"
                    header={this.props.variableName}
                    state={this.state.edit}
                    buttons={[
                        {
                            text: 'Mégse',
                            props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                try {
                                    this.setState({edit: false, variable: this.props.variable});
                                } catch (e) {

                                }
                            }
                        },
                        {
                            text: 'Alapértelmezett',
                            props: {color: "danger", disabled: this.props.disabled || this.props.isLoading},
                            onClick: async () => {
                                this.props.onVariableChanged(this.props.variableName, null);
                            }
                        },
                        {
                            text: 'Mehet',
                            props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || JSON.stringify(this.props.variable) === JSON.stringify(this.state.variable)},
                            onClick: async () => {
                                if (!isEqual(this.props.variable, this.state.variable)) {
                                    this.props.onVariableChanged(this.props.variableName, this.state.variable);
                                } else {
                                    this.setState({edit: false});
                                }
                            }
                        }
                    ]}
                >
                    {NodeEditor.nodes[this.props.type].editor({...this.props, variable: this.state.variable, saveChanges: (field, value) => this.setState({variable: {...this.state.variable, [field]: value}})})}
                </Modal>
            </Portal>
        </div>;
    }
}